// Tutorial steps that point INSIDE a drawer (the cart, a lead row's detail panel): derived from the markup, no stored field.
//   <div data-tour-drawer="cart" data-tour-drawer-open="[data-action='cart#open']" data-tour-drawer-close="[data-action='cart#close']" hidden>
// A drawer root carries the selectors of the page's OWN open / close controls; the selector is looked up in the drawer,
// then in each ancestor up to the document (the cart's button lives in the top nav, a row's „Więcej" in the row). Opening
// is a real click on that control — the page opens its drawer the way it always does (no fake DOM).
import { instances } from "./target.js"

const ATTR = "data-tour-drawer"
const q = (anchor) => `[data-tour="${String(anchor).replace(/["\\]/g, "\\$&")}"]`

/** the control of the page that opens / closes this drawer, or null */
export function control(drawer, kind) {
  const selector = drawer.getAttribute(`${ATTR}-${kind}`)
  if (!selector) return null
  for (let node = drawer; node; node = node.parentElement) {
    const found = node.querySelector(selector)
    if (found) return found
  }
  return drawer.ownerDocument.querySelector(selector)
}

/** the element(s) a step points at, whether or not they are visible now (a closed drawer hides them) */
function candidates(root, step) {
  if (!step?.anchor) return []
  if (step.scope) {
    const scopes = instances(root, step.scope)
    const picked = (step.nth || 1) === 1 ? scopes : [scopes[(step.nth || 1) - 1]].filter(Boolean)
    return picked.flatMap((scope) => [...scope.querySelectorAll(q(step.anchor))])
  }
  return [...root.querySelectorAll(q(step.anchor))].filter((el) => !el.closest("template"))
}

/** the drawer that holds the step's element and can be opened (its open control exists), or null */
export function drawerFor(root, step) {
  for (const el of candidates(root, step)) {
    const drawer = el.closest(`[${ATTR}]`)
    if (drawer && control(drawer, "open")) return drawer
  }
  return null
}

/** open it the page's way (a click on its open control); false when there is no control */
export function openDrawer(drawer) {
  const button = control(drawer, "open")
  if (!button) return false
  button.click()
  return true
}

/** close it the page's way; only when it is open (not hidden) */
export function closeDrawer(drawer) {
  if (!drawer || drawer.hidden || drawer.closest("[hidden]")) return
  control(drawer, "close")?.click()
}
